import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.k43_1 = operation;
        this.l43_1 = null;
        this.m43_1 = Companion_getInstance().a44_1;
        this.n43_1 = null;
        this.o43_1 = null;
        this.p43_1 = null;
        this.q43_1 = null;
        this.r43_1 = null;
        this.s43_1 = null;
        this.t43_1 = null;
        this.u43_1 = null;
        this.v43_1 = null;
        this.w43_1 = null;
        this.x43_1 = null;
        this.y43_1 = true;
        this.z43_1 = null;
      }
      b44(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.l43_1 = requestUuid;
        return this;
      }
      c44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.m43_1 = executionContext;
        return this;
      }
      d44(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.v43_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      e44(url) {
        // Inline function 'kotlin.apply' call
        this.n43_1 = url;
        return this;
      }
      f44(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.o43_1 = httpMethod;
        return this;
      }
      g44(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.p43_1 = httpHeaders;
        return this;
      }
      h44(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.p43_1;
        tmp.p43_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      i44(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.r43_1 = sendApqExtensions;
        return this;
      }
      j44(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.s43_1 = sendDocument;
        return this;
      }
      k44(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.q43_1 = enableAutoPersistedQueries;
        return this;
      }
      l44(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.t43_1 = canBeBatched;
        return this;
      }
      m44(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.u43_1 = ignoreUnknownKeys;
        return this;
      }
      n44(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.w43_1 = retryOnError;
        return this;
      }
      o44(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.x43_1 = failFastIfOffline;
        return this;
      }
      p44(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.y43_1 = sendEnhancedClientAwareness;
        return this;
      }
      q44(extensions) {
        // Inline function 'kotlin.apply' call
        this.z43_1 = extensions;
        return this;
      }
      l38() {
        var tmp1_operation = this.k43_1;
        var tmp0_elvis_lhs = this.l43_1;
        var tmp2_requestUuid = tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs;
        var tmp3_executionContext = this.m43_1;
        var tmp4_httpMethod = this.o43_1;
        var tmp5_httpHeaders = this.p43_1;
        var tmp6_sendApqExtensions = this.r43_1;
        var tmp7_sendDocument = this.s43_1;
        var tmp8_enableAutoPersistedQueries = this.q43_1;
        var tmp9_canBeBatched = this.t43_1;
        var tmp10_ignoreApolloClientHttpHeaders = this.v43_1;
        var tmp11_retryOnError = this.w43_1;
        var tmp12_failFastIfOffline = this.x43_1;
        var tmp13_ignoreUnknownKeys = this.u43_1;
        var tmp14_sendEnhancedClientAwareness = this.y43_1;
        var tmp15_url = this.n43_1;
        var tmp16_extensions = this.z43_1;
        return new (ApolloRequest())(tmp1_operation, tmp2_requestUuid, tmp3_executionContext, tmp15_url, tmp4_httpMethod, tmp5_httpHeaders, tmp6_sendApqExtensions, tmp7_sendDocument, tmp8_enableAutoPersistedQueries, tmp9_canBeBatched, tmp13_ignoreUnknownKeys, tmp10_ignoreApolloClientHttpHeaders, tmp11_retryOnError, tmp12_failFastIfOffline, tmp14_sendEnhancedClientAwareness, tmp16_extensions);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, url, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreUnknownKeys, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness, extensions) {
        this.r44_1 = operation;
        this.s44_1 = requestUuid;
        this.t44_1 = executionContext;
        this.u44_1 = url;
        this.v44_1 = httpMethod;
        this.w44_1 = httpHeaders;
        this.x44_1 = sendApqExtensions;
        this.y44_1 = sendDocument;
        this.z44_1 = enableAutoPersistedQueries;
        this.a45_1 = canBeBatched;
        this.b45_1 = ignoreUnknownKeys;
        this.c45_1 = ignoreApolloClientHttpHeaders;
        this.d45_1 = retryOnError;
        this.e45_1 = failFastIfOffline;
        this.f45_1 = sendEnhancedClientAwareness;
        this.g45_1 = extensions;
      }
      h45() {
        return this.i45(this.r44_1);
      }
      i45(operation) {
        return (new (Builder())(operation)).b44(this.s44_1).c44(this.t44_1).e44(this.u44_1).f44(this.v44_1).g44(this.w44_1).i44(this.x44_1).j44(this.y44_1).k44(this.z44_1).l44(this.a45_1).n44(this.d45_1).o44(this.e45_1).d44(this.c45_1).m44(this.b45_1).p44(this.f45_1).q44(this.g45_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
